<template>
    <div class="printContainer grey">
        <div v-if="spiel" class="page" style="position: relative">
            <spiel-bericht-print-header :spiel="spiel" :liga="liga" title="Schiedsrichterblatt">
            </spiel-bericht-print-header>
            <spiel-bericht-print-header-team  class="heim d-inline-block"
                                              :spiel="spiel" type="heim">
            </spiel-bericht-print-header-team>
            <spiel-bericht-print-header-team  class="gast d-inline-block"
                                              :spiel="spiel" type="gast">
            </spiel-bericht-print-header-team>
        <!-- Referee Checklist -->
            <p class="mt-3 mb-0">Der <span class="font-weight-bold text-decoration-underline">
                Schiedsrichter</span> bestätigt mit seiner Unterschrift, dass die unten angeführten
                Punkte (1 bis 5) eingehalten bzw. nicht eingehalten wurden.</p>
            <table style="font-size: 12px">
                <tr class="text-center font-weight-bold"><td></td><td></td><td>JA</td><td>NEIN</td></tr>
                <tr v-for="(srCheck, i) in checkListSR" :key="i">
                    <td style="width: 9%; vertical-align: top"
                        class="font-weight-bold text-right pr-2">{{srCheck.nr}})</td>
                    <td>{{srCheck.text1}} - wenn
                        <span class="font-weight-bold">NEIN</span>
                        {{srCheck.text2}}:
                        <div class="writeBox mt-6 mb-2"></div>
                    </td>
                    <td class="text-center">
                        <div class="checkBox mx-3"></div></td>
                    <td class="text-center">
                        <div class="checkBox mx-3"></div></td>
                </tr>
            </table>
        <!-- Spieler Checklist -->
            <p class="mt-3 mb-1">Die beiden <span class="font-weight-bold text-decoration-underline">
                Sportkapitäne</span> bestätigt mit ihren
                Unterschriften, dass die unten angeführten Punkte (6 bis 11)
                vom Schiedsrichter eingehalten bzw. nicht eingehalten wurden.</p>
            <table style="font-size: 12px" class="text-center mb-7">
                <tr class="font-weight-bold" style="font-size: 14px">
                    <td colspan="2">HEIMVEREIN</td>
                    <td colspan="2"></td>
                    <td colspan="2">GASTVEREIN</td>
                </tr>
                <tr class="font-weight-bold">
                    <td>JA</td><td>NEIN</td>
                    <td colspan="2"></td>
                    <td>JA</td><td>NEIN</td>
                </tr>
                <tr v-for="(spielerCheck) in checkListSpieler" :key="spielerCheck.nr">
                    <td class="text-center">
                        <div class="checkBox mx-4"></div></td>
                    <td class="text-center">
                        <div class="checkBox mx-4"></div></td>
                    <td style="width: 9%; vertical-align: top"
                        class="font-weight-bold text-right pr-2">{{spielerCheck.nr}})</td>
                    <td style="width: 90%" class="pb-2 text-left">{{spielerCheck.text}}</td>
                    <td class="text-center">
                        <div class="checkBox mx-4"></div></td>
                    <td class="text-center">
                        <div class="checkBox mx-4"></div></td>
                </tr>
            </table>
        <!-- signatures -->
            <spiel-bericht-print-sign class="signature d-inline-block" type="left">
                Kapitän/in Heim:
                <span class="font-weight-bold">{{spiel.heim.captain}}</span>
            </spiel-bericht-print-sign>
            <spiel-bericht-print-sign class="signature d-inline-block" type="left">
                Schiedsrichter/in:
                <span class="font-weight-bold">{{spiel.referee.name}}</span>
            </spiel-bericht-print-sign>
            <spiel-bericht-print-sign class="signature d-inline-block" type="full">
                Kapitän/in Gast:
                <span class="font-weight-bold">{{spiel.gast.captain}}</span>
            </spiel-bericht-print-sign>
            <!-- navigation box -->
            <v-btn fab dark bottom right
                   color="primary" style="position: absolute; right: -80px; top: 15px; z-index: 15"
                   @click="openPrint()">
                <v-icon >mdi-printer</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import SpielBerichtPrintSign from "./spielBerichtPrint_Sign";
    import SpielBerichtPrintHeader from "./spielBerichtPrint_Header";
    import SpielBerichtPrintHeaderTeam from "./spielBerichtPrint_HeaderTeam";
    export default {
        components: {
            SpielBerichtPrintHeaderTeam,
            SpielBerichtPrintHeader,
                      SpielBerichtPrintSign},
        name: "spiel-bericht-print-sr-blatt",
        data: () => ({
            spiel: null,
            landesverband: null,
            checkListSR: [
                {
                    nr: 1,
                    text1: 'Ordnungsgemäßes Antreten bei Begrüßung und Verabschiedung (6 Spieler in ' +
                    'Sportkleidung lt. Mannschaftsaufstellungsliste)',
                    text2: 'welcher Verein'
                },
                {
                    nr: 2,
                    text1: 'Antreten mit Spielerpass',
                    text2: 'namentliche Nennung'
                },
                {
                    nr: 3,
                    text1: 'Rechtzeitiges Abgeben der Mannschaftsaufstellungsliste',
                    text2: 'welcher Verein'
                },
                {
                    nr: 4,
                    text1: 'Rechtzeitiges Erscheinen zum Start',
                    text2: 'namentliche Nennung'
                },
                {
                    nr: 5,
                    text1: 'Einheitliche Sportkleidung',
                    text2: 'namentliche Nennung'
                },
            ],
            checkListSpieler: [
                { nr: 6, text: 'Rechtzeitiges Erscheinen (mind. 45 Minuten vor dem Spiel)'},
                { nr: 7, text: 'Unaufgeforderte Vorlage des Schiedsrichterausweises'},
                { nr: 8, text: 'Ordnungsgemäße Kleidung samt Schiedsrichteremblem'},
                { nr: 9, text: 'Ordnungsgemäßes Auftreten (korrekt)'},
                { nr: 10, text: 'Spielleitung erfolgte nach Regeln der Sportordnung'},
                { nr: 11, text: 'Ordnungsgemäße Durchführung der An- und Absagen'},
            ],
        }),
        computed: {
            liga(){
                return this.spiel && this.landesverband ?
                    this.landesverband.ligen[this.spiel.getLigaId()].nameFull : '';
            }
        },
        created(){
            this.setSpiel();
            //window.print();
        },
        methods: {
            setSpiel(){
                db.collection("spiele").doc(this.$route.query.id).get()
                    .then((doc) => {
                    if (doc.exists) {
                        console.log("Document data:", doc.data());
                        this.spiel = new Spiel();
                        this.spiel.setFromDataObject(doc.data());
                        this.setLandesverband();
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            setLandesverband(){
                db.collection("landesverbaende").doc(this.spiel.saison.lvId).get()
                    .then((doc) => {
                        if (doc.exists) {
                            console.log("Document data:", doc.data());
                            this.landesverband = doc.data();
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            openPrint(){
                window.print()
            }
        },
    }
</script>

<style scoped>
    @media print{@page {size: portrait; margin: 0}}
    p {font-size: 12px; }
    .heim { width: 49.5%; margin-right: 0.5% }
    .gast { width: 49.5%; margin-left: 0.5% }
    .checkBox {width: 20px; height: 20px; border: solid 1px black}
    .writeBox {width: 95%; height: 10px; border-bottom: dotted 1px black}
    .signature {width: 33%}

    /*https://codepen.io/rafaelcastrocouto/pen/LFAes*/
</style>